webpackJsonp([22],{

/***/ 514:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_register_vue__ = __webpack_require__(723);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed31a86a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_register_vue__ = __webpack_require__(819);
function injectStyle (ssrContext) {
  __webpack_require__(817)
}
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_register_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed31a86a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_register_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 680:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: {
    short: 'BEC',
    long: 'INSTALACIONES BEC'
  }
});

/***/ }),

/***/ 723:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_config_theme__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_config_app__ = __webpack_require__(680);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _this = this;

    return {
      appName: __WEBPACK_IMPORTED_MODULE_1_config_app__["a" /* default */].name,
      isMounted: false,
      path: this.$route.path.toLowerCase(),
      passwordOne: '',
      passwordTwo: '',
      appendIconOne: function appendIconOne() {
        return _this.visibilityOne = !_this.visibilityOne;
      },
      appendIconTwo: function appendIconTwo() {
        return _this.visibilityTwo = !_this.visibilityTwo;
      },
      visibilityOne: true,
      visibilityTwo: true
    };
  },
  mounted: function mounted() {
    this.isMounted = true;
  },


  methods: {
    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getCardStyle: function getCardStyle() {
      return 'theme--' + __WEBPACK_IMPORTED_MODULE_0_config_theme__["a" /* default */].route[this.path].styles.card;
    },

    /**
     * Get custom parameters or use the default parameters.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    register: function register() {
      var _this2 = this;

      this.$store.dispatch('api/register', {
        passwordOne: this.passwordOne,
        passwordTwo: this.passwordTwo
      }).then(function () {
        if (_this2.$store.getters['api/isAuthorizedUser']) {
          return _this2.$router.push('/dashboard');
        }
        _this2.$store.dispatch('snackbar/show', 'Usuario o contraseña incorrectos');
      });
    }
  }
});

/***/ }),

/***/ 817:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(818);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(495)("1631097d", content, true, {});

/***/ }),

/***/ 818:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(494)(true);
// imports


// module
exports.push([module.i, "#register-page{background:#373c40;-webkit-transform-style:preserve-3d;transform-style:preserve-3d;height:100%}#register-page h2{color:#fff;padding:20px;font-size:2.5em}#register-page>.container{max-width:500px;margin:0 auto;position:relative;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}#register-page .logo{height:200px}", "", {"version":3,"sources":["/var/www/localhost/public_html/app/vues/src/pages/register.vue"],"names":[],"mappings":"AACA,eACE,mBAAoB,AACpB,oCAAqC,AACrC,4BAA6B,AAC7B,WAAa,CACd,AACD,kBACI,WAAa,AACb,aAAc,AACd,eAAiB,CACpB,AACD,0BACI,gBAAiB,AACjB,cAAe,AACf,kBAAmB,AACnB,QAAS,AACT,mCAAoC,AAC5B,0BAA4B,CACvC,AACD,qBACI,YAAc,CACjB","file":"register.vue","sourcesContent":["\n#register-page {\n  background: #373c40;\n  -webkit-transform-style: preserve-3d;\n  transform-style: preserve-3d;\n  height: 100%;\n}\n#register-page h2 {\n    color: white;\n    padding: 20px;\n    font-size: 2.5em;\n}\n#register-page > .container {\n    max-width: 500px;\n    margin: 0 auto;\n    position: relative;\n    top: 50%;\n    -webkit-transform: translateY(-50%);\n            transform: translateY(-50%);\n}\n#register-page .logo {\n    height: 200px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 819:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.isMounted),expression:"isMounted"}]},[_c('v-layout',{attrs:{"row":"","align-center":"","justify-center":""}},[_c('img',{staticClass:"logo",attrs:{"src":"http://localhost:8088/app/vue/static/images/login/logo.png","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[_c('h2',[_vm._v("REGÍSTRATE EN "+_vm._s(_vm.appName))])]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","align-center":"","justify-center":""}},[_c('v-btn',{attrs:{"to":"/register/store","outline":"","color":"primary","large":""}},[_vm._v("Comerciante")]),_vm._v(" "),_c('v-btn',{attrs:{"to":"/register/installer","outline":"","color":"primary","large":""}},[_vm._v("Instalador")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/22.7d7f1fa92c61aa175639.js